
      import FontItalic from './font-italic.vue'
      import type { App, Plugin } from 'vue'

      export const FontItalicPlugin: Plugin = {
        install(app: App) {
          app.component('FontItalic', FontItalic)
        },
      }
      export { FontItalic }
      